module.exports = __webpack_public_path__ + "static/media/IntegrationIcon.3563d244.svg";